export default __webpack_public_path__ + "static/media/eye-slash.2e268ae6.png";